import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import AsyncSelect from "react-select/async";
import debounce from "lodash/debounce";
import { normalizeApi } from "modules/shared/api";

// Use callback to workaround https://github.com/JedWatson/react-select/issues/3075#issuecomment-450194917
const search = (searchTerm, callback) => {
  axios
    .get(`/api/startups/search_merchant_store?q=${searchTerm}`)
    .then(result => normalizeApi(result.data, "merchantStores"))
    .then(callback);
};

const debouncedSearch = debounce(search, 500);

const StoreSearchBar = props => {
  return (
    <div className="search-bar">
      <AsyncSelect
        loadOptions={debouncedSearch}
        cacheOptions
        placeholder="Marktname/GLN"
        getOptionLabel={o =>
          `${o.shippingAddress.recipientName} (${o.shippingAddress.street}, ${o.shippingAddress.postalCode}, ${o.shippingAddress.city})`
        }
        noOptionsMessage={() => "Kein Markt gefunden"}
        loadingMessage={() => "Wird geladen…"}
        getOptionValue={o => o.id}
        onChange={newVal =>
          props.onChange({
            id: newVal.id,
            name: newVal.shippingAddress.recipientName,
            region: newVal.merchantAccounts
              ? newVal.merchantAccounts[0].region
              : null,
          })
        }
      />
    </div>
  );
};

StoreSearchBar.propTypes = {
  onSelectStore: PropTypes.func,
};

export default StoreSearchBar;
